<template>
  <v-menu
    dense
    v-if="user"
    small
    offset-x
    right
    content-class="theme--dark v-sheet--outlined elevation-8">
    <template v-slot:activator="{ attrs, on }">
      <v-list-item style="max-width: 88%" class="pa-0 ma-0" v-bind="attrs" v-on="on">
        <v-avatar class="d-inline-flex text-center user-avatar mr-2" color="primary" size="28">
          <!-- <v-img :src="user.picture"></v-img> -->
          <user-avatar :user="user" disable-open-link hide-roles no-tooltip icon></user-avatar>
        </v-avatar>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item-content class="pa-0" v-bind="attrs" v-on="on">
              <v-list-item-title
                style="color: var(--v-grey-base)"
                class="subtitle-2"
                v-if="user.firstName">
                {{ user.firstName }}
              </v-list-item-title>
              <v-list-item-subtitle
                style="color: var(--v-grey-base)"
                class="caption"
                v-if="user.email">
                {{ user.email }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <div
            class="font-weight-medium d-flex flex-column"
            style="text-transform: none; letter-spacing: normal">
            <div v-if="user.firstName">
              {{ user.firstName + ' ' + user.lastName }}
            </div>
            <span class="fs-11px opacity-87">
              <div>{{ user.email }}</div>
            </span>
          </div>
        </v-tooltip>
        <v-list-item-action>
          <v-icon small>mdi-chevron-down</v-icon>
        </v-list-item-action>
      </v-list-item>
    </template>
    <v-list class="user-profile-menu-list">
      <v-list-item link @click="logout">
        <v-list-item-icon class="mr-2 justify-center">
          <v-icon small>mdi-logout</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title color="secondary">Logout</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  import { mapGetters } from 'vuex';
  import UserAvatar from '@Share/components/UserAvatar.vue';

  export default {
    data() {
      return {};
    },
    computed: {
      ...mapGetters('ACCOUNT', {
        user: 'GET_USER',
        company: 'GET_COMPANY',
      }),
      isOwner() {
        return this.user.id == this.company.ownerId;
      },
    },

    methods: {
      logout() {
        this.$store.dispatch('ACCOUNT/LOGOUT');
      },
    },
    components: { UserAvatar },
  };
</script>
<style lang="scss">
  .user-profile-menu-list {
    .v-list-item {
      height: 32px;
      min-height: 32px;
    }
    .v-list-item__title {
      font-size: 14px;
    }
    .v-list-item__icon {
      align-self: center;
    }
  }
  .user-avatar {
    border: 1px solid var(--v-primary-base);
  }
  .company-name {
    max-width: 100%;
    overflow: hidden;
    width: auto;
    text-overflow: ellipsis;
    padding: 0 4px;
  }
</style>
